import Modal from 'react-modal'
import React from 'react'
import { Input, Button } from 'loyal-react'
import PropTypes from 'prop-types'

const BranchModal = ({
  modal,
  branchName,
  branchId,
  toggleModal,
  updateState,
  submit
}) => {
  return (
    <Modal
      isOpen={modal}
      onRequestClose={toggleModal}
      style={{
        content: {
          top: '40%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          width: '600px'
        }
      }}
    >
      <div className='row'>
        <div className='col-12'>
          <h2 className='txt-initial color-brand-1 mr-auto'>
            {branchId ? 'Editar' : 'Adicionar'} Filial
          </h2>
        </div>
      </div>
      <hr />
      <div className='row mt-2'>
        <div className='col-12'>
          <Input
            id='search'
            label='Nome'
            value={branchName}
            onChange={(e) => { updateState('name', e.target.value) }}
          />
        </div>
      </div>
      <div className='row mt-2'>
        <div className='col-6'>
          <Button
            id='closeModal'
            name='closeModal'
            className='btn btn-sm mx-0'
            text='Fechar'
            onClick={toggleModal}
          />
        </div>
        <div className='col-6'>
          <Button
            id='save'
            name='save'
            className='btn btn-sm txt-uppercase txt-center btn-featured'
            text='Salvar'
            onClick={submit}
          />
        </div>
      </div>
    </Modal>
  )
}

BranchModal.propTypes = {
  modal: PropTypes.bool,
  branchName: PropTypes.string,
  branchId: PropTypes.number,
  toggleModal: PropTypes.func,
  updateState: PropTypes.func,
  submit: PropTypes.func
}

export default BranchModal



// WEBPACK FOOTER //
// ./src/features/FocalPoint/Branch/BranchModal.js